












































import {Component, Prop, Inject, Emit, Watch, Vue} from "vue-property-decorator";

import {_winWidth, _winHeight} from '~/stories_widget/util/window-size';
import {IAnimateOptions, animate} from '~/stories_widget/util/animation';
import {WidgetStoriesOptions} from "~/stories_widget/models/WidgetStoriesOptions";

import Article, {ArticleOptions} from "~/stories_widget/models/Article";
import IssueArticle, {IssueArticleOptions} from "~/stories_widget/models/IssueArticle"
import StoriesViewer from '~/stories_widget/components/Stories/StoriesViewer/StoriesViewer';

const namespace: string = 'article';

@Component({
    name: "ArticleViewer",
})

export default class ArticleViewer extends Vue {
    /** property значения которые получает компонент */
    @Prop({type: String}) id!: string; // article slug_or_id for view
    @Prop({type: String}) type!: string; // articleType article || issueArticle
    @Prop({type: String, default: ''}) uid!: string;

    headerTitle: string = '';

    @Watch('uid')
    onUidChanged(to: string, from: string) {
        if (to !== '') {
            this.showArticle();
        }
    }

    iframeOnLoad(el: Event): void {
        const iframeElement = (<HTMLFrameElement>el.target);
        if (iframeElement.contentWindow !== null && iframeElement.contentWindow.document !== null) {
            if (iframeElement.contentWindow !== null && iframeElement.contentWindow.document !== null) {
                /** since ie does not support Array.from and Object.forEach */
                [].slice.call(iframeElement.contentWindow.document.querySelectorAll('a')).forEach((el: Element) => {
                    el.setAttribute('target', '_blank');
                });
            }
        }
    }



    showArticle(): void {
        if (this.type === IssueArticleOptions.TYPE) {
            this.$store.dispatch(`${namespace}/FETCH_ISSUE_ARTICLES`, [this.id]).then(_ => {

                let issueArticle = null;
                this.$store.getters[`${namespace}/issueArticles`].forEach((item: Article) => {
                    if (item.slug_or_id === this.id) {
                        issueArticle = item;
                    }
                });
                if (issueArticle !== null) {

                    this.headerTitle = (<IssueArticle>issueArticle).magazine_name;

                    this.updateIframeContent((<IssueArticle>issueArticle).content);

                }

            });

        } else if (this.type === ArticleOptions.TYPE) {
            this.$store.dispatch(`${namespace}/FETCH_ARTICLES`, [this.id]).then(_ => {
                let article: Article|null = null;
                this.$store.getters[`${namespace}/articles`].forEach((item: Article) => {
                    if (item.slug_or_id === this.id) {
                        article = item;
                    }
                });
                if (article !== null) {
                    this.headerTitle = (<Article>article).magazine_name;
                    this.updateIframeContent((<Article>article).content);
                }

            });
        }
    }

    updateIframeContent(content: string): void {
        if (this.$refs['articleIframe'] !== null && this.$refs['articleIframe'] !== undefined) {
            const iframeElement = (<HTMLFrameElement>this.$refs['articleIframe']);
            if (iframeElement.contentWindow !== null && iframeElement.contentWindow.document !== null) {
                iframeElement.contentWindow.document.write(content);
                iframeElement.contentWindow.document.close();
            }
        }
    }

    closeArticleViewer(): void {

        const iframeElement = (<HTMLFrameElement>this.$refs['articleIframe']);
        if (iframeElement.contentWindow !== null) {
            iframeElement.src = 'about:blank';
        }

        (<StoriesViewer>this.$parent).closeArticleViewer();

        (<StoriesViewer>this.$parent).resumeAndEnableViewerUIForArticleViewer();
    }

}

